const emValidationRegex = /^-?\d*\.?\d+em$/;
const pxValidationRegex = /^-?\d*\.?\d+px$/;

const emExtractRegex = /^(-?\d*\.?\d+)em$/;
const pxExtractRegex = /^(-?\d*\.?\d+)px$/;

/**
 * Calculates the number in pixels from a base font size and an ephemeral unit.
 * Note: only supports decimals with leading 0 (i.e. 0.5)
 * e.g. 1.5em of a 16px font-size -> 24
 *
 * @param baseFont The base font size
 * @param em The
 */
export function getNumberFromEmAndBaseFont(
  baseFont: string,
  em: string
): number {
  const baseFontMatch = baseFont.match(pxExtractRegex);
  const emMatch = em.match(emExtractRegex);

  if (
    !baseFontMatch ||
    !baseFontMatch[1] ||
    !pxValidationRegex.test(baseFont)
  ) {
    throw new Error(`baseFont must be in format "Xpx", was ${baseFont}`);
  }

  if (!emMatch || !emMatch[1] || !emValidationRegex.test(em)) {
    throw new Error(`em must be in format "Xem", was ${em}`);
  }

  const baseFontNum = parseFloat(baseFontMatch[1]);
  const emNum = parseFloat(emMatch[1]);

  return emNum * baseFontNum;
}
